import { Avatar, Box, Button, Dialog, DialogContent, DialogTitle } from "@mui/material";
import { useTranslation } from "react-i18next";
import styles from "./MetadataDialogs.module.scss";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { Link, useNavigate } from "react-router-dom";

interface DialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const ContinueDialog: React.FC<DialogProps & { action: () => void }> = ({ open, setOpen, action }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Dialog className={styles.continueDialog} open={open} fullWidth maxWidth="sm">
      <DialogTitle>{t("Published")}</DialogTitle>
      <DialogContent>
        <Box className={styles.waiting}>
          <h2>{t("congratulations")}</h2>
          <ul>
            <li>
              <p>{t("publishedMessages.0")}</p>
            </li>
            <li>
              <p>{t("publishedMessages.1")}</p>
            </li>
          </ul>
          <p className={styles.orange}>{t("publishedMessages.2")}</p>
          <Avatar>
            <MailOutlineIcon />
          </Avatar>
          <p>
            {t("youCanFollowTheStatusInTheSection")}
            <Link to={"/myinbox"}>{t("myPublications")}</Link>
          </p>
          <Button variant="text" onClick={() => navigate("/")}>
            {t("backToHome")}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
